var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { startTransition, useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { Layout, Grid } from "antd";
import NewsApi from "./../../api/NewsApi.js";
import { withScrollToTop } from "./../../hoc";
import Loader from "./../../components/loader/Loader.js";
import { initialParams } from "./newsService";
import NewsCard from "./newsCard/NewsCard";
const { Content } = Layout;
const { useBreakpoint } = Grid;
const News = ({ leftSidebar, rightSidebar }) => {
  const layoutRef = useRef(null);
  const screens = useBreakpoint();
  const getNewsApi = NewsApi.getNews();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      var _a;
      const isBottom = window.innerHeight + window.scrollY >= ((_a = layoutRef.current) == null ? void 0 : _a.clientHeight) - 200;
      if (isBottom && !loading && hasMore) {
        getMoreNews();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasMore, loading]);
  useEffect(() => {
    setOffset(0);
    getNews(__spreadValues({}, initialParams), (data) => setNews(data != null ? data : []));
    return () => {
      getNewsApi.cancel();
    };
  }, []);
  const getNews = async (params, callback) => {
    var _a;
    flushSync(() => setLoading(true));
    try {
      const response = await getNewsApi.call(params);
      callback == null ? void 0 : callback(response.data);
      setHasMore(((_a = response.data) == null ? void 0 : _a.length) === params.limit);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      startTransition(() => {
        setLoading(false);
      });
    }
  };
  const getMoreNews = () => {
    const newOffset = offset + initialParams.limit;
    startTransition(() => {
      getNews(
        __spreadProps(__spreadValues({}, initialParams), {
          offset: newOffset
        }),
        (data) => {
          setNews((prev) => [...prev, ...data != null ? data : []]);
          setOffset(newOffset);
        }
      );
    });
  };
  const hasSidebars = leftSidebar && rightSidebar;
  const columns = !screens.md || hasSidebars ? 1 : 3;
  return /* @__PURE__ */ jsxs(
    Layout,
    {
      style: {
        gap: screens.md ? 24 : 16,
        marginBottom: 20
      },
      className: "container",
      ref: layoutRef,
      children: [
        screens.lg && leftSidebar,
        loading && !news.length ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(Content, { children: /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
              columnGap: !screens.md ? 0 : "14px"
            },
            children: news.map((item) => /* @__PURE__ */ jsx(NewsCard, { item }, item.id))
          }
        ) }),
        screens.lg && rightSidebar
      ]
    }
  );
};
var stdin_default = withScrollToTop(News);
export {
  stdin_default as default
};
